import { ON_SERVER } from '.';

const safeErrors = [
  'Script error.',
  'Mutation',
  'mutation',
  'MUTATION',
  'closed before response',
  'removed from DOM',
];

const registerErrorHandlers = (): void => {
  if (ON_SERVER) return;

  window.addEventListener('error', (event) => {
    if (safeErrors.some((err: string) => event.message.includes(err))) return;
    console.error(event.message); // eslint-disable-line no-console
  });

  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      console.error(event.reason.message); // eslint-disable-line no-console
    },
  );
};

export default registerErrorHandlers;
